import React, { memo, useContext, useEffect, useState, createContext, useRef, useMemo } from "react";
import { PlusOutlined, LeftCircleOutlined, RightCircleOutlined, DeleteOutlined, LoadingOutlined, FolderOpenOutlined, UploadOutlined, DownOutlined, ExclamationCircleFilled, MoreOutlined } from "@ant-design/icons";
import { Button, Image, Popconfirm, Upload, Modal, Tree, theme, Space, Dropdown, Input } from "antd";
import ImageService from "services/image";
import FolderService from "services/folder";

import { useApp } from "contexts/app";
import { CSS } from "@dnd-kit/utilities";
import { useAuth } from "contexts/auth";
import _, { forEach } from "lodash"

const { useToken } = theme;



const FolderPicker = ({ open, onOk, onCancel, onFolderSelected }) => {
  const [folder, setFolder] = useState();

  const [files, setFiles] = useState([]);

  const [treeData, setTreeData] = useState([])

  const [folderList, setFolderList] = useState([])
  const [selectedTreeKeys, setSelectedTreeKeys] = useState(['root'])
  const [expandedKeys, setExpandedKeys] = useState(['root'])


  useEffect(() => {
    console.log("open", open)
    if (open) {

          loadFolder();
    }
    setFiles([])
  },[open]);


 


  const createChildNode = (id, lst) => {
    var childs = lst.filter(x => x.parent_id == id).map(x => ({ ...x }));

    if (childs.length == 0)
      return null;
    for (let index = 0; index < childs.length; index++) {
      var child = childs[index];
      child.title = child.name;
      child.key = child.id;

      child.children = createChildNode(child.id, lst);

    }
    return childs

  }

  const loadFolder = async () => {
    const service = new FolderService();
    var lst = await service.list();


    const treeData = [
      {
        title: 'Thư Mục Gốc',
        key: 'root',
        children: createChildNode("root", lst),
      },


    ];
    setTreeData(treeData);
    setFolderList(lst);
  }




  const onSelect = (selectedKeys, info) => {
    var key = _.last(selectedKeys)
    setFolder(_.last(selectedKeys));
    setSelectedTreeKeys(selectedKeys)

  };

  const onSelectFolder = () => {
    if (folder) {
      onFolderSelected(folder);
    }
    onCancel();
  }

  const footer = () => {
    return (
      <div style={{ width: "100%", display: "flex" }}>
        <Space>
          <Button onClick={onSelectFolder} type="primary">Ok</Button>
        </Space>
      </div>

    )
  }


  const getTitle = () => {
    var selectedFolder = folderList.find(x => x.id == folder);
    if (selectedFolder) {
      return (

        <Space>
          {selectedFolder.name}

        </Space>
      )

      return selectedFolder.name;
    }

    return "Chọn thư mục"
  }



  return (
    <>

      <Modal title={getTitle()} open={open} onCancel={onCancel} width={300} onOk={onSelectFolder} >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: 200 }}>
            <Tree
              defaultExpandedKeys={['root']}
              defaultSelectedKeys={['root']}
              selectedKeys={selectedTreeKeys}
              expandedKeys={expandedKeys}
              onExpand={keys => setExpandedKeys(keys)}
              onSelect={onSelect}
              selectable
              treeData={treeData}
              style={{ width: 200, height: 400, overflowY: "scroll" }}
            />
          </div>

        </div>


      </Modal>

    </>
  )
}










export default FolderPicker;
